import { AbstractRequestor } from '../shared/AbstractRequestor';
import { type IParams } from '../shared/IRequestor';
import { type AuthToken } from '../types';

export interface IOauthApi {
  getToken(params: unknown, authToken?: AuthToken): Promise<unknown>;
}

export class OauthApi implements IOauthApi {
  private readonly requestor: AbstractRequestor;

  constructor(baseURL: string, timeout: number) {
    this.requestor = new (class extends AbstractRequestor {})({ baseURL, timeout });
  }

  /**
   * @deprecated
   */
  async getToken(
    params: IParams,
    authToken?: AuthToken | string,
  ): Promise<{
    access_token: string;
    refresh_token: string;
  }> {
    const res: any = await this.requestor.request({
      method: 'GET',
      url: '/oauth/token',
      options: {
        params,
        headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined,
      },
    });

    if (!res.data?.access_token) {
      console.error('Received error response when getting token', res);
      throw Error('Received error response when getting token:' + JSON.stringify(res));
    }

    return res.data;
  }
}
